type State = Record<string, Array<string>>;

export default State;

export const DefaultState = {};
